import React, { Component } from "react";
import { Route, Redirect } from "react-router";
import { Layout } from "./components/Layout";
import { Login } from "./components/Login";
import { Bootstrap } from "./components/Bootstrap";
import { ResetPassword } from "./components/ResetPassword";
import { constant } from "./helpers";
import {
  Home,
  Admin,
  ShippingUpload,
  ProductUpload,
  ProductionUpload,
  ProductionPlanning,
  EmailTest,
  ShippingHistoryUpload,
  ProductionHistoryUpload,
  ProductInventoryChangeLog,
  EquipmentMaintenanceRecord,
  EditEquipment,
  EditMaintenanceRecord,
  EquipmentCalibrationRecord,
  EditCalibrationRecord,
  EquipmentDashboard,
  Equipment,
  Impersonate,
  PartsUpload,
  InventoryUpload,
  InventoryCycleCount,
  CurrentInventoryTotals,
  CycleCountChangeHistory,
  SalesReport,
  ProductionMetricsReport,
  COADashboard,
  ProductCoaResultDetails,
  RequestLog
} from "./components";
import Alert from "react-s-alert";
import "react-s-alert/dist/s-alert-default.css";
import "react-s-alert/dist/s-alert-css-effects/stackslide.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserAlt,
  faBolt,
  faFileImage,
  faAngleUp,
  faHandPaper,
  faAngleDown,
  faArchive,
  faBackspace,
  faImage,
  faBars,
  faBroom,
  faSync,
  faCheck,
  faCheckSquare,
  faCheckCircle,
  faComment,
  faComments,
  faCloudDownloadAlt,
  faEnvelope,
  faStickyNote,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronCircleDown,
  faEdit,
  faFileWord,
  faThumbsUp,
  faThumbsDown,
  faArrowsAlt,
  faArrowsAltH,
  faArrowsAltV,
  faExclamation,
  faFastForward,
  faFolderMinus,
  faFolderPlus,
  faFolder,
  faChevronRight,
  faEye,
  faFilePdf,
  faFile,
  faInfo,
  faInfoCircle,
  faFileCsv,
  faExternalLinkAlt,
  faFileDownload,
  faDownload,
  faFileUpload,
  faUpload,
  faFont,
  faLayerGroup,
  faTrashAlt,
  faUser,
  faUsers,
  faUserNurse,
  faSort,
  faStepBackward,
  faStepForward,
  faFilter,
  faHighlighter,
  faMinusCircle,
  faPaste,
  faPlusCircle,
  faPlus,
  faFileAlt,
  faCommentDots,
  faSave,
  faTimesCircle,
  faTimes,
  faAlignJustify,
  faCheckDouble,
  faReply,
  faEraser,
  faFastBackward,
  faChevronLeft,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faTags,
  faTasks,
  faRedo,
  faUndo,
  faSms,
  faKeyboard,
  faBriefcase,
  faChartLine,
  faExchangeAlt,
  faSpinner,
  faSkullCrossbones,
  faBookmark,
  faSearch,
  faClone,
  faFlag,
  faCopy,
  faThLarge,
  faSearchMinus,
  faSearchPlus,
  faSignInAlt,
  faSignOutAlt,
  faPaperPlane,
  faClipboardList,
  faClipboardCheck,
  faFileImport,
  faAngleDoubleLeft,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faExclamationTriangle,
  faShare,
  faTable,
  faExclamationCircle,
  faQuestionCircle,
  faQuestion,
  faQuoteLeft,
  faQuoteRight,
  faCaretSquareDown,
  faExpandArrowsAlt,
  faPlusSquare,
  faCompressArrowsAlt,
  faCompress,
  faHourglassHalf,
  faUserTie,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faArrowUp,
  faArrowDown,
  faExpand,
  faUserMd,
  faCaretSquareUp,
  faBookOpen,
  faBalanceScaleRight,
  faShieldAlt,
  faDoorOpen,
  faRuler,
  faRecycle,
  faMinus,
  faUserPlus,
  faUserSlash,
  faDoorClosed,
  faPaperclip,
  faSmoking,
  faPhoneAlt,
  faHistory,
  faClock,
  faLock,
  faUnlock,
  faUnlockAlt,
  faMask,
  faObjectGroup,
  faCommentAlt,
  faCaretDown,
  faCaretUp,
  faFolderOpen,
  faTag,
  faFilm,
  faSortAmountUp,
  faSortAmountDown,
  faMortarPestle,
  faThList,
  faDollyFlatbed,
  faMapMarkerAlt,
  faTachometerAlt,
  faPeopleCarry,
  faEyeSlash,
  faCalendarAlt,
  faTools,
  faCogs,
  faCalendarTimes,
  faHouseDamage,
  faBalanceScale,
  faWeight,
  faWrench,
  faToolbox,
  faTheaterMasks,
  faRetweet,
  faChevronDown,
  faChevronUp,
  faSitemap,
  faVial,
  faVials,
  faUserCheck,
  faUserTimes,
    faTrash,
  faList
} from "@fortawesome/free-solid-svg-icons";

library.add(faUserAlt);
library.add(faBolt);
library.add(faUsers);
library.add(faAngleUp);
library.add(faArrowsAlt);
library.add(faArrowsAltH);
library.add(faArrowsAltV);
library.add(faArrowDown);
library.add(faArrowUp);
library.add(faImage);
library.add(faFile);
library.add(faThumbsUp);
library.add(faThumbsDown);
library.add(faFileCsv);
library.add(faCommentDots);
library.add(faFileAlt);
library.add(faAlignJustify);
library.add(faAngleDown);
library.add(faArchive);
library.add(faBackspace);
library.add(faBars);
library.add(faCloudDownloadAlt);
library.add(faHandPaper);
library.add(faFolderMinus);
library.add(faFolderPlus);
library.add(faFolder);
library.add(faQuestionCircle);
library.add(faExclamationCircle);
library.add(faBroom);
library.add(faSync);
library.add(faTimes);
library.add(faFilePdf);
library.add(faFileImage);
library.add(faChevronLeft);
library.add(faCheck);
library.add(faCheckSquare);
library.add(faCheckCircle);
library.add(faPaperPlane);
library.add(faChevronCircleRight);
library.add(faChevronCircleLeft);
library.add(faChevronCircleDown);
library.add(faCopy);
library.add(faEnvelope);
library.add(faStickyNote);
library.add(faEdit);
library.add(faFileWord);
library.add(faExclamation);
library.add(faQuestion);
library.add(faFastBackward);
library.add(faExternalLinkAlt);
library.add(faEye);
library.add(faInfo);
library.add(faInfoCircle);
library.add(faSort);
library.add(faStepBackward);
library.add(faStepForward);
library.add(faReply);
library.add(faChevronRight);
library.add(faFastForward);
library.add(faFilter);
library.add(faFileDownload);
library.add(faDownload);
library.add(faFileUpload);
library.add(faUpload);
library.add(faFont);
library.add(faLayerGroup);
library.add(faHighlighter);
library.add(faMinusCircle);
library.add(faPlusCircle);
library.add(faPlus);
library.add(faSave);
library.add(faExternalLinkAlt);
library.add(faEye);
library.add(faEdit);
library.add(faTags);
library.add(faTasks);
library.add(faTimesCircle);
library.add(faTrashAlt);
library.add(faBackspace);
library.add(faBars);
library.add(faUser);
library.add(faUserNurse);
library.add(faCheckDouble);
library.add(faEraser);
library.add(faLongArrowAltRight);
library.add(faLongArrowAltLeft);
library.add(faLongArrowAltUp);
library.add(faLongArrowAltDown);
library.add(faPaste);
library.add(faRedo);
library.add(faUndo);
library.add(faKeyboard);
library.add(faSms);
library.add(faBriefcase);
library.add(faChartLine);
library.add(faExchangeAlt);
library.add(faSpinner);
library.add(faBookmark);
library.add(faSkullCrossbones);
library.add(faSearch);
library.add(faClone);
library.add(faFlag);
library.add(faComment);
library.add(faComments);
library.add(faThLarge);
library.add(faSearchMinus);
library.add(faSearchPlus);
library.add(faSignInAlt);
library.add(faSignOutAlt);
library.add(faClipboardList);
library.add(faClipboardCheck);
library.add(faFileImport);
library.add(faAngleDoubleLeft);
library.add(faAngleLeft);
library.add(faAngleRight);
library.add(faAngleDoubleRight);
library.add(faExclamationTriangle);
library.add(faShare);
library.add(faTable);
library.add(faQuoteLeft);
library.add(faQuoteRight);
library.add(faCaretSquareDown);
library.add(faExpandArrowsAlt);
library.add(faPlusSquare);
library.add(faCompressArrowsAlt);
library.add(faCompress);
library.add(faHourglassHalf);
library.add(faUserTie);
library.add(faArrowAltCircleUp);
library.add(faArrowAltCircleDown);
library.add(faExpand);
library.add(faUserMd);
library.add(faCaretSquareUp);
library.add(faBookOpen);
library.add(faBalanceScaleRight);
library.add(faShieldAlt);
library.add(faDoorOpen);
library.add(faRuler);
library.add(faRecycle);
library.add(faMinus);
library.add(faUserPlus);
library.add(faUserSlash);
library.add(faDoorClosed);
library.add(faPaperclip);
library.add(faSmoking);
library.add(faPhoneAlt);
library.add(faHistory);
library.add(faClock);
library.add(faLock);
library.add(faUnlock);
library.add(faMask);
library.add(faObjectGroup);
library.add(faCommentAlt);
library.add(faCaretDown);
library.add(faCaretUp);
library.add(faFolderOpen);
library.add(faTag);
library.add(faFilm);
library.add(faSortAmountUp);
library.add(faSortAmountDown);
library.add(faUnlockAlt);
library.add(faMortarPestle);
library.add(faThList);
library.add(faDollyFlatbed);
library.add(faMapMarkerAlt);
library.add(faTachometerAlt);
library.add(faPeopleCarry);
library.add(faEyeSlash);
library.add(faCalendarAlt);
library.add(faTools);
library.add(faCogs);
library.add(faCalendarTimes);
library.add(faHouseDamage);
library.add(faBalanceScale);
library.add(faWeight);
library.add(faWrench);
library.add(faToolbox);
library.add(faTheaterMasks);
library.add(faRetweet);
library.add(faStepForward);
library.add(faStepBackward);
library.add(faChevronDown);
library.add(faChevronUp);
library.add(faSitemap);
library.add(faVial);
library.add(faVials);
library.add(faUserCheck);
library.add(faUserTimes);
library.add(faTrash);
library.add(faList);

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props);
    const token = localStorage.getItem(constant.Token);
    let currentUser = token
      ? JSON.parse(localStorage.getItem(constant.CurrentUser))
      : null;
    const isImpersonating = localStorage.getItem(constant.AdminToken)
      ? true
      : false;
    this.state = {
      authenticationToken: token,
      currentUser: currentUser,
      appVersion: localStorage.getItem("version") || "",
      impersonating: isImpersonating,
      message: null
    };
    this.logoff = this.logoff.bind(this);
    this.setCurrentUser = this.setCurrentUser.bind(this);
    this.setImpersonation = this.setImpersonation.bind(this);
    this.clearImpersonation = this.clearImpersonation.bind(this);
  }

  logoff() {
    const { Token, AdminToken, CurrentUser, AdminUser } = constant;

    if (this.state.impersonating) {
      localStorage.removeItem(AdminToken);
      localStorage.removeItem(AdminUser);
    }

    localStorage.removeItem(Token);
    localStorage.removeItem(CurrentUser);

    this.setState({
      currentUser: null,
      authenticationToken: null,
      impersonating: false
    });
  }

  setCurrentUser(user) {
    const { Token, CurrentUser } = constant;

    localStorage.setItem(CurrentUser, JSON.stringify(user));
    let newState = {
      currentUser: user
    };
    if (user.token) {
      localStorage.setItem(Token, user.token);
      newState.authenticationToken = user.token;
      window.TurnOnCycleCount = user.turnOffCycleCount;
    }
    this.setState(newState);
  }

  setImpersonation(user, new_token) {
    const { Token, AdminToken, CurrentUser, AdminUser } = constant;
    if (this.state.impersonating) {
      return;
    }
    // remember the admin user's details
    const adminUser = JSON.parse(localStorage.getItem(CurrentUser));
    const adminUserToken = localStorage.getItem(Token);

    //clear localstorage
    localStorage.removeItem(Token);
    localStorage.removeItem(CurrentUser);
    // set the impersonation details
    localStorage.setItem(Token, new_token);
    localStorage.setItem(CurrentUser, JSON.stringify(user));
    // remember the admin details for later
    localStorage.setItem(AdminToken, adminUserToken);
    localStorage.setItem(AdminUser, JSON.stringify(adminUser));
    this.setState({
      impersonating: true,
      currentUser: user,
      authenticationToken: new_token
    });
  }

  clearImpersonation() {
    const { Token, AdminToken, CurrentUser, AdminUser } = constant;
    if (!this.state.impersonating) {
      return; // do not allow clear of the primary user if we're not impersonating
    }
    // get the original admin user
    const adminUser = JSON.parse(localStorage.getItem(AdminUser));
    const adminUserToken = localStorage.getItem(AdminToken);
    // clear localstorage
    localStorage.removeItem(AdminToken);
    localStorage.removeItem(AdminUser);
    // set the admin user back as primary
    localStorage.setItem(Token, adminUserToken);
    localStorage.setItem(CurrentUser, JSON.stringify(adminUser));
    this.setState({
      impersonating: false,
      currentUser: adminUser,
      authenticationToken: adminUserToken
    });
  }

  render() {
    const authenticated = this.state.authenticationToken !== null;
    const AuthRoute = ({ component: Component, ...extraProps }) => {
      return (
        <Route
          {...extraProps}
          render={props => {
            return authenticated ? (
              <Component {...extraProps} currentUser={this.state.currentUser} />
            ) : (
              <Redirect to="/login" />
            );
          }}
        />
      );
    };

    const LoginRoute = ({ ...extraProps }) => (
      <Route
        {...extraProps}
        render={props => {
          return authenticated ? (
            <Redirect to="/" />
          ) : (
            <Login {...extraProps} setCurrentUser={this.setCurrentUser} />
          );
        }}
      />
    );

    return (
      <Layout
        currentUser={this.state.currentUser}
        logoff={this.logoff}
        appVersion={this.state.appVersion}
        impersonating={this.state.impersonating}
        clearImpersonation={this.clearImpersonation}
      >
        <AuthRoute exact path="/" component={Home} logoff={this.logoff} />
        <LoginRoute
          exact
          path="/login"
          currentUser={this.state.currentUser}
          impersonating={this.state.impersonating}
          setImpersonation={this.setImpersonation}
        />
        <Route exact path="/bootstrap" component={Bootstrap} />
        <Route exact path="/resetPassword/:token" component={ResetPassword} />
        <AuthRoute
          exact
          path="/admin/:tab?"
          component={Admin}
          currentUser={this.state.currentUser}
          impersonating={this.state.impersonating}
          setImpersonation={this.setImpersonation}
        />
        <Route
          exact
          path="/impersonate"
          render={props => (
            <Impersonate
              {...props}
              currentUser={this.state.currentUser}
              impersonating={this.state.impersonating}
              setImpersonation={this.setImpersonation}
            />
          )}
        />
        <AuthRoute
          exact
          path="/production_planning"
          component={ProductionPlanning}
        />
        <AuthRoute exact path="/sales_summary" component={ShippingUpload} />
        <AuthRoute
          exact
          path="/production_summary"
          component={ProductionUpload}
        />
        <AuthRoute exact path="/product_upload" component={ProductUpload} />
        <AuthRoute
          exact
          path="/production_history_upload"
          component={ProductionHistoryUpload}
        />
        <AuthRoute
          exact
          path="/shipping_history_upload"
          component={ShippingHistoryUpload}
        />
        <AuthRoute
          exact
          path="/equipment_maintenance_records"
          component={EquipmentMaintenanceRecord}
        />
        <AuthRoute
          exact
          path="/equipment"
          component={Equipment}
          viewOnly={true}
        />
        <Route exact path="/edit_equipment/:id?" component={EditEquipment} />
        <Route
          exact
          path="/product_inventory_changelog/:productid"
          component={ProductInventoryChangeLog}
        />
        <Route
          exact
          path="/maintenance_record/:id?"
          component={EditMaintenanceRecord}
        />
        <AuthRoute
          exact
          path="/equipment_calibration_records"
          component={EquipmentCalibrationRecord}
        />
        <Route
          exact
          path="/calibration_record/:id?"
          component={EditCalibrationRecord}
        />
        <AuthRoute
          exact
          path="/equipment_dashboard"
          component={EquipmentDashboard}
        />
        <AuthRoute exact path="/emailtest" component={EmailTest} />
        <AuthRoute exact path="/parts_upload" component={PartsUpload} />
        <AuthRoute exact path="/inventory_upload" component={InventoryUpload} />
        <AuthRoute
          exact
          path="/inventory_cycle_count"
          component={InventoryCycleCount}
        />
        <AuthRoute
          exact
          path="/current_inventory_totals"
          component={CurrentInventoryTotals}
        />
        <AuthRoute
          exact
          path="/cycle_count_change_history"
          component={CycleCountChangeHistory}
        />
        <AuthRoute
          exact
          path="/sales_report"
          component={SalesReport}
        />
        <AuthRoute
          exact
          path="/production_metrics_report"
          component={ProductionMetricsReport}
        />
        <AuthRoute
          exact
          path="/requestlog"
          component={RequestLog}
        />
        <AuthRoute
          exact
          path="/coa"
          component={COADashboard}
        />
        <AuthRoute
          exact
          path="/coa_result/:id?"
          component={ProductCoaResultDetails}//SACHA
        />
        <Alert
          effect="stackslide"
          position="top-right"
          stack={{ limit: 5 }}
          timeout={8000}
          html={true}
        />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js